/**
 * Worksheet Goals Constants
 */

export const DISCIPLINE_OPTIONS: { value: string; label: string }[] = [
  { value: 'all_disciplines', label: 'All Disciplines' },
  { value: 'SN', label: 'SN - Skilled Nursing' },
  { value: 'PT', label: 'PT - Physical Therapy' },
  { value: 'OT', label: 'OT - Occupational Therapy' },
  { value: 'ST', label: 'ST - Speech Therapy' },
  { value: 'MSW', label: 'MSW - Medical Social Work' },
  { value: 'HHA', label: 'HHA - Home Health Aide' },
];
